module.exports = __webpack_public_path__ + "img/logo_rund.eb3e560.png";